global.jQuery = global.$ = require('jquery');
import './lib/mainMenu';
import './lib/indexHero';
import './lib/slidedContent';
import './lib/tgl';
import './lib/contextMenu';
import './lib/gallery';
import './lib/inlineGallery';
import './lib/timeline';
import './lib/newsFeed';
import './lib/modals';
import './lib/lazyLoading';
import './lib/partners';
// import './lib/cells';
// import './lib/map';
